/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { AlertCircle } from 'styled-icons/feather/AlertCircle';
import { ReactComponent as InfoSVG } from '../../assets/images/icons/info.svg';
import { ReactComponent as NewInfoSvG } from '../../assets/images/icons/newInfo.svg';


function QuestionIcon(props) {
  const { className } = props;
  const styles = [className, 'icon'];
  return (
    <AlertCircle {...props} className={styles} />
  );
}

function InfoIcon(props) {
  const { className, theme } = props;
  const styles = [className, 'icon'];

  return (
    <InfoSVG {...props} fill={theme.simulation.iconColor} className={styles} />
  );
}

function NewInfoIcon(props) {
  const { className, theme, ...rest } = props;
  const styles = [className, 'icon'];

  const fillColor = theme?.simulation?.iconColor || 'currentColor';

  return (
    <NewInfoSvG
      {...rest}
      fill={fillColor}
      className={styles}
    />
  );
}

export { QuestionIcon, InfoIcon, NewInfoIcon };
